import { Icon } from '../Icon/Icon';

export interface IShareSocialProps {
    title: string;
    summary?: string;
    shareUrl?: string;
    shareText?: string;
}

export const ShareSocial = (props: IShareSocialProps): JSX.Element => {
    const onShare = () => {
        const shareData = {
            title: props.title,
            text: props.summary,
            url: props.shareUrl ?? window.location.href,
        };
        if (navigator.share) {
            navigator
                .share(shareData)
                .then(() => console.log('Share successful'))
                .catch((error) => console.error('Error sharing:', error));
        } else {
            console.error('Share not supported on this browser');

            const emailSubject = encodeURIComponent(props.title);
            const emailBody = encodeURIComponent(props.summary ?? '');
            const emailUrl = `mailto:?subject=${emailSubject}&body=${props.shareUrl ?? window.location.href}%0D%0A%0D%0A${emailBody}`;
            window.location.href = emailUrl;
        }
    };
    return (
        <span className="share-social">
            <button type="button" className="share-social__button btn btn-link unstyled-button d-flex align-items-center" onClick={onShare}>
                <span className="share-social__button-icon d-inline-flex me-1">
                    <Icon symbol="share" />
                </span>
                <span>{props.shareText ?? 'Dela'}</span>
            </button>
        </span>
    );
};
